module.exports = __webpack_public_path__ + "img/download.c0276016.gif";